import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../css/Invoice.css"
import { order } from "../../components/Service/Oder";
import { useDispatch } from "react-redux"; // import useDispatch
import { addToCart } from "../../redux/cart/cartActions"; // import action
import { useNavigate, useSearchParams } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
import Swal from "sweetalert2";
import PaymentService from "../../components/Service/NeoXService";
import { createPayPal } from "../../components/Service/PaypalService";
import { updateWallet } from "../../components/Service/Transaction";
import useLanguage from '../../Hooks/useLanguage';
import { useTranslation } from 'react-i18next';

function Invoice(props) {
    const paymentService = new PaymentService();

    const navi = useNavigate();
    const { onChildError } = props; // Nhận các props từ cha

    const [price, setPrice] = useState(null);
    const [usdPrice, setUsdPrice] = useState("0.00");
    const [billDetails, setBillDetails] = useState([]);
    const [checkeror, setcheckerro] = useState("");
    const [discountprice, setdiscountprice] = useState(null);
    const dispatch = useDispatch(); // sử dụng dispatch
    const [promoCode, setPromoCode] = useState("");
    const [discountSuccess, setDiscountSuccess] = useState(""); // New state for success message

    const [finalSubtotal, setFinalSubtotal] = useState(props?.baseAmount);
    // console.log("props?.baseAmount", props?.baseAmount)
    const [searchParams] = useSearchParams(); // Hook lấy tham số từ URL
    useLanguage();

    const { t } = useTranslation();
    // Chuyển đổi chu kỳ thanh toán
    // console.log("props.selectedFeatures", props.selectedFeatures[0]?.price)
    useEffect(() => {
        if (props?.baseAmount !== undefined) {
            setFinalSubtotal(props?.baseAmount);
        }
    }, [props?.baseAmount]);

    useEffect(() => {
        // Lấy giá trị mã khuyến mãi từ URL
        const urlPromoCode = searchParams.get("promocode");
        if (urlPromoCode) {
            setPromoCode(urlPromoCode);
        }
    }, [searchParams]);
    useEffect(() => {
        if (props.totalAmount && props.totalAmount > 0) {
            Cookies.set("orderAmount", props.totalAmount, { expires: 1 }); // Lưu cookie trong 1 ngày
            const convertedUsdPrice = (props.totalAmount / 24000).toFixed(2);
            setUsdPrice(convertedUsdPrice);
            setPrice(props.totalAmount);
            // console.log("Saved order amount:", props.totalAmount);
        }
        setcheckerro("");
    }, [props.totalAmount, props.selectedChildSystem]);
    // useEffect(() => {
    //     console.log("selectedSystem", props?.selectedproduct)
    //     console.log("selectedRegion", props?.selectedRegion);
    //     console.log("selectedChildSystem", props?.selectedChildSystem)
    //     console.log("packages", props?.packages)
    //     console.log("Period", props?.selectedCycle)
    //     console.log("selectedFeatures", props?.selectedFeatures)
    //     console.log("Subtotal", props?.baseAmount)
    //     console.log("Discount", props?.pricekm)
    //     console.log("Post-Discount", props?.postdiscount)
    //     console.log("Payment", price)
    // }, [props?.regions, props?.selectedChildSystem, props?.packages, props?.selectedFeatures, props?.baseAmount, price, props?.selectedSystem])
    // useEffect(() => {
    //     const savedOrderAmount = Cookies.get("orderAmount");
    //     if (savedOrderAmount) {
    //         // console.log("Loaded order amount from cookie:", savedOrderAmount);
    //         setPrice(parseFloat(savedOrderAmount));
    //     }
    // }, []);

    // if (price === null) {
    //     return <div>Đang tải thông tin hóa đơn...</div>;
    // }

    const handleCreateInvoice = async () => {

        if (props?.option === "wallet") {
            const result = await Swal.fire({
                title: "Bạn có chắc chắn?",
                html: `Bạn có chắc chắn muốn thay đổi gói dịch vụ của máy ảo không?<br><br>
                <span style="color: #dc3454; font-weight: bold;">Lưu ý: Máy ảo hiện tại sẽ tắt trong quá trình thay đổi gói dịch vụ!</span>`, showCancelButton: true,
                confirmButtonText: "Confirm",
                cancelButtonText: "Cancel",
                reverseButtons: true,
                showCloseButton: true,
                cancelButtonColor: "#dc3545",
                confirmButtonColor: "#007bff",
                customClass: {
                    popup: 'swal2-popup-centered custom-popup',
                    confirmButton: 'custom-confirm-button'

                },
                width: '600px',
                backdrop: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                preConfirm: async () => {
                    const confirmButton = document.querySelector('.swal2-confirm');
                    const cancelButton = document.querySelector('.swal2-cancel');
                    confirmButton.innerHTML = `<span class="loading-spinner"></span>`;
                    confirmButton.classList.add("swal2-loading");
                    confirmButton.disabled = true;

                    try {
                        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/create-invoice-changepackage-wallet`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "Authorization": `Bearer ${Cookies.get("Token")}`
                            },
                            body: JSON.stringify({
                                promo_code: promoCode,
                                promo_value: "N/A",
                                amount: props.paymentAmount,
                                des: "Upgrade package",
                                note: "Invoice for package change",
                                sub_total: props.subtotal,
                                tax: props.taxAmount,
                                total: props.paymentAmount,
                                payment_method: "wallet",
                                credit: 0,
                                tax_rate: 10,
                                invoice_items: [
                                    {
                                        sub_total: props.subtotal,
                                        taxed: 0,
                                        payment_method: "wallet",
                                        des: `Package: ${props.selectedproduct?.name}`,
                                        notes: `<br>${props?.currentpackagename} => ${props?.package?.name}`, // Hỗ trợ HTML
                                        package_id: props.package?.id,
                                        current_package_id: props?.currentpackageid,
                                        order_id: parseInt(props.order_detailsID, 10)
                                    },
                                ],
                            })
                        });

                        if (!response.ok) {
                            throw new Error("Có lỗi xảy ra khi tạo hóa đơn thanh toán bằng ví.");
                        }

                        Swal.showValidationMessage(`
                            <div style="display: flex; align-items: center; gap: 10px; color: green; font-size: 14px;">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="green" class="bi bi-check-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zM8 0a8 8 0 1 1 0 16A8 8 0 0 1 0 8a8 8 0 0 1 8-8z"/>
                                    <path d="M10.97 4.97a.235.235 0 0 1 .331.045c.104.123.087.304-.036.408L7.477 9.354a.25.25 0 0 1-.353 0L5.384 7.664a.25.25 0 0 1 .353-.353l1.597 1.597 3.536-4.24a.235.235 0 0 1 .045-.038z"/>
                                </svg>
                                <span>Thành công! Máy ảo đã được khởi động lại.</span>
                            </div>
                        `);
                        Swal.hideLoading();
                        confirmButton.innerHTML = "Confirm";
                        confirmButton.classList.remove("swal2-loading");
                        confirmButton.disabled = true;
                        confirmButton.style.display = "none";

                        cancelButton.innerText = 'Close';
                        cancelButton.style.visibility = 'visible';
                        cancelButton.style.position = 'relative';
                        cancelButton.style.transform = 'none';


                        setTimeout(() => {
                            Swal.close();
                        }, 2000);

                        // delayFetchData(2000);

                        setTimeout(() => {
                            navi('/thank-you/changepackage');
                        }, 5000);

                    } catch (error) {
                        Swal.showValidationMessage(`
                            <span style="color: red; font-size: 14px; font-weight: bold;">
                                ❌ Lỗi: ${error.message}
                            </span>
                        `);
                        Swal.hideLoading();
                    }
                }
            });
            return;
        }



        if (props?.paymentAmount > 0) {
            const result = await Swal.fire({
                title: "Bạn có chắc chắn?",
                html: `Bạn có chắc chắn muốn thay đổi gói dịch vụ của máy ảo không?<br><br>
                <span style="color: #dc3454; font-weight: bold;">Lưu ý: Máy ảo hiện tại sẽ tắt trong quá trình thay đổi gói dịch vụ!</span>`, showCancelButton: true,
                confirmButtonText: "Confirm",
                cancelButtonText: "Cancel",
                showCancelButton: true,
                confirmButtonText: "Xác nhận",
                cancelButtonText: "Hủy",
                cancelButtonColor: "#dc3545",
                confirmButtonColor: "#007bff",
                reverseButtons: true,
                showCloseButton: true,
                customClass: {
                    popup: 'swal2-popup-centered custom-popup',
                    confirmButton: 'custom-confirm-button'

                },
                width: '600px',
                backdrop: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                preConfirm: async () => {
                    const confirmButton = document.querySelector('.swal2-confirm');
                    const cancelButton = document.querySelector('.swal2-cancel');
                    confirmButton.innerHTML = `<span class="loading-spinner"></span>`;
                    confirmButton.classList.add("swal2-loading");
                    confirmButton.disabled = true;
                    try {
                        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/create-invoice-changepackage`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "Authorization": `Bearer ${Cookies.get("Token")}`
                            },
                            body: JSON.stringify({
                                promo_code: promoCode,
                                promo_value: "N/A",
                                amount: props.paymentAmount,
                                des: "Upgrade package",
                                note: "Invoice for package change",
                                sub_total: props.subtotal,
                                tax: props.taxAmount,
                                total: props.paymentAmount,
                                payment_method: props?.option,
                                credit: 0,
                                tax_rate: 10,
                                invoice_items: [
                                    {
                                        sub_total: props.subtotal,
                                        taxed: 0,
                                        payment_method: props?.option,
                                        des: `Package: ${props.selectedproduct?.name}`,
                                        notes: `<br>${props?.currentpackagename} => ${props?.package?.name}`, // Hỗ trợ HTML
                                        package_id: props.package?.id,
                                        current_package_id: props?.currentpackageid,
                                        order_id: parseInt(props.order_detailsID, 10)
                                    },
                                ],
                            })
                        });

                        if (!response.ok) {
                            throw new Error("Có lỗi xảy ra khi thay đổi gói dịch vụ của máy ảo.");
                        }

                        const data = await response.json();
                        console.log("Thanh toán thành công:", data);

                        const invoiceID = data?.invoice?.id;
                        Cookies.set("invoiceID", invoiceID, { expires: 1 });

                        let paymentUrl = "";
                        const token = Cookies.get("Token");

                        const updateTransaction = async (paymentMethod, gatewayId) => {
                            try {
                                const transactionResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/create-transaction`, {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                        "Authorization": `Bearer ${Cookies.get("Token")}`
                                    },
                                    body: JSON.stringify({
                                        status: 0,
                                        invoiceId: invoiceID,
                                        amount: props?.paymentAmount,
                                        gatewayId: gatewayId,
                                        type: 3,
                                        paymentMethod: paymentMethod
                                    }),
                                });

                                if (!transactionResponse.ok) {
                                    throw new Error(`Failed to create transaction for ${paymentMethod}`);
                                }

                            } catch (error) {
                                console.error(`Error updating wallet for ${paymentMethod}:`, error);
                            }
                        };
                        switch (props?.option) {
                            case "paypal":
                                console.log("Trước khi gọi updateTransaction");
                                await updateTransaction("Paypal", 2);
                                console.log("Sau khi gọi updateTransaction");
                                paymentUrl = await createPayPal(invoiceID, props?.paymentAmount, "upgrade", props?.order_detailsID, props?.package?.id, "");
                                break;
                            case "napas":
                                await updateTransaction("ATM", 1)

                                paymentUrl = await paymentService.createPayment(props?.paymentAmount, invoiceID, 'ATM', "upgrade", props?.order_detailsID, props?.package?.id);
                                break;
                            case "visa":

                                console.log("Trước khi gọi updateTransaction");
                                await updateTransaction("Credit Card", 1);
                                console.log("Sau khi gọi updateTransaction");

                                paymentUrl = await paymentService.createPayment(props?.paymentAmount, invoiceID, 'CC', "upgrade", props?.order_detailsID, props?.package?.id);
                                break;
                            case "qr":
                                await updateTransaction("QR", 1)

                                paymentUrl = await paymentService.createPayment(props?.paymentAmount, invoiceID, 'QR', "upgrade", props?.order_detailsID, props?.package?.id);
                                break;
                            case "bank":
                                await updateTransaction("Bank transfer", 4)

                                navi('/thank-you/bank', { state: { invoiceID } });
                                return;


                            default:
                                throw new Error("Phương thức thanh toán không hợp lệ.");
                        }

                        if (paymentUrl) {
                            window.location.href = paymentUrl;
                        }
                    } catch (error) {
                        Swal.showValidationMessage(`
                        <span style="color: red; font-size: 14px; font-weight: bold;">
                            ❌ Lỗi: ${error.message}
                        </span>
                    `);
                        Swal.hideLoading();
                    }
                }
            });

            if (!result.isConfirmed) {
                Swal.close();
            }
        }
        else {
            try {
                const transactionResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/create-transaction`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${Cookies.get("Token")}`
                    },
                    body: JSON.stringify({
                        status: 1,
                        invoiceId: props.order_detailsID,
                        amount: props.subtotal,
                        gatewayId: 3,
                        type: 1,
                    }),
                });

                const result = await Swal.fire({
                    title: "Bạn có chắc chắn?",
                    html: `Bạn có chắc chắn muốn thay đổi gói dịch vụ của máy ảo không?<br><br>
                    <span style="color: #dc3454; font-weight: bold;">Lưu ý: Máy ảo hiện tại sẽ tắt trong quá trình thay đổi gói dịch vụ!</span>`, showCancelButton: true,
                    confirmButtonText: "Confirm",
                    cancelButtonText: "Cancel",
                    showCancelButton: true,
                    confirmButtonText: "Xác nhận",
                    cancelButtonText: "Hủy",
                    cancelButtonColor: "#dc3545",
                    confirmButtonColor: "#007bff",
                    reverseButtons: true,
                    showCloseButton: true,

                    customClass: {
                        popup: 'swal2-popup-centered custom-popup',
                        confirmButton: 'custom-confirm-button'

                    },
                    width: '600px',
                    backdrop: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    preConfirm: async () => {
                        document.querySelector('.swal2-confirm').style.visibility = 'hidden';
                        document.querySelector('.swal2-cancel').style.visibility = 'hidden';
                        Swal.showLoading();

                        try {
                            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/update-payment-downgrade`, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    "Authorization": `Bearer ${Cookies.get("Token")}`
                                },
                                body: JSON.stringify({
                                    amount: props.subtotal,
                                    package_id: props.package?.id,
                                    order_detail_id: props.order_detailsID
                                })
                            });

                            if (!response.ok) {
                                throw new Error("Có lỗi xảy ra khi thay đổi gói dịch vụ của máy ảo.");
                            }
                            else {
                                Swal.fire({
                                    icon: "success",
                                    title: "Thanh toán thành công!",
                                    text: "Gói dịch vụ của bạn đã được thay đổi.",
                                    confirmButtonText: "OK",
                                    timer: 5000,
                                    timerProgressBar: true
                                }).then(() => {
                                    navi('/thank-you/changepackage');
                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 1000);
                                });

                            }



                        } catch (error) {
                            Swal.showValidationMessage(`
                            <span style="color: red; font-size: 14px; font-weight: bold;">
                                ❌ Lỗi: ${error.message}
                            </span>
                        `);
                            Swal.hideLoading();
                        }
                    }
                });
            } catch (error) {
                Swal.fire({
                    icon: "error",
                    title: "Lỗi cập nhật số dư!",
                    text: error.message,
                    confirmButtonText: "Thử lại"
                });
            }
        }

    };

    const updateWalletPayment = async (invoiceID, totalAmount, token) => {
        try {
            const data = await updateWallet(totalAmount);
            console.log("Wallet updated successfully:", data);

            await fetch(`${process.env.REACT_APP_API_URL}/api/v1/create-transaction`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({
                    status: 1,
                    orderId: invoiceID,
                    amount: totalAmount,
                    gatewayId: 3,
                    type: 1,
                }),
            });

            await fetch(`${process.env.REACT_APP_API_URL}/api/v1/update-payment-downgrade`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({
                    status: "COMPLETED",
                    invoiceId: invoiceID,
                    paymentMethod: "wallet"
                }),
            });

            window.location.href = '/thank-you/bank';
        } catch (error) {
            console.error("Error updating wallet:", error);
        }
    };


    const handleDiscount = () => {
        if (promoCode.toLowerCase() === "tidadigi") {
            const discount = 0.4 * props?.baseAmount;
            setdiscountprice(discount);
            const updatedSubtotal = props?.baseAmount - discount;
            setFinalSubtotal(updatedSubtotal);
            setcheckerro("");
            setDiscountSuccess("Mã của bạn đã được áp dụng.");

        } else {
            setcheckerro("Mã không hợp lệ");
            setDiscountSuccess("");

        }
    };

    // console.log("finalSubtotal", finalSubtotal)

    return (
        <div className="invoice-container container p-3" style={{ background: "#f7faff", borderRadius: "8px" }}>
            <div className="summary-section">
                <h3 style={{ color: "#007bff", fontWeight: "bold", textAlign: "center", marginBottom: "30px", marginTop: "10px" }}>Summary</h3>
                {/* 
                <div className="row summary-item mb-2">
                    <div className="col-6">Name</div>
                    <div className="col-6 text-end">{props?.selectedproduct?.name || "N/A"}</div>
                </div> */}
                <div className="row summary-item mb-2">
                    <div className="col-6">{t("Current Plan")} <span style={{ fontSize: "12px" }}>{props?.currentpackagename}</span></div>

                    <div className="col-6 text-end">
                        {props?.currentplan != null
                            ? props?.currentplan.toLocaleString("vi-VN")
                            : "N/A"}
                    </div>
                </div>

                <hr></hr>

                <div className="row summary-item mb-2">
                    <div className="col-6">{t("New Plan")} <span style={{ fontSize: "12px" }}>{props?.package?.name}</span></div>
                    <div className="col-6 text-end">
                        {props?.pricepupgrade != null
                            ? props?.pricepupgrade?.toLocaleString("vi-VN")
                            : "N/A"}
                    </div>
                </div>


                <div className="row summary-item mb-2">
                    <div className="col-6">{t("Remaining days")}</div>
                    <div className="col-6 text-end">

                        {props?.remainingDays}
                    </div>
                </div>

                {/* {props?.backup ? (
                    <div className="row summary-item mb-3">
                        <div className="col-6">Backup
                        </div>
                        <div className="col-6 text-end">
                            {props?.backup}
                        </div>
                    </div>
                ) : null} */}






                {props.backupPrice !== null ? (
                    <div className="row summary-item mb-3">
                        <div className="col-6">{t("Backup")}: {t("Yes")} </div>
                        <div className="col-6 text-end">
                            {(props?.backupPrice) !== null
                                ? (props?.backupPrice).toLocaleString("vi-VN")
                                : "N/A"}
                        </div>

                    </div>
                ) : (
                    <div className="col-6">{t("Backup")}: {t("No")}  </div>

                )}
                <hr></hr>
                <div className="row summary-item mb-3">
                    <div className="col-6"><h4 style={{ fontSize: "17px" }}>{t("Subtotal")}</h4></div>
                    <div className="col-6 text-end">
                        {(props?.subtotal) !== null
                            ? (props?.subtotal).toLocaleString("vi-VN")
                            : "N/A"}
                    </div>

                </div>
                {discountprice ? (
                    <div className="row summary-item mb-3">
                        <div className="col-6">{t("Discount")}</div>
                        <div className="col-6 text-end">
                            - {discountprice.toLocaleString("vi-VN")}
                        </div>
                    </div>
                ) : null}
                <hr></hr>

                {discountprice ? (

                    <div className="row summary-item mb-3">
                        <div className="col-6">{t("Post-discount")}</div>
                        <div className="col-6 text-end">
                            {(props?.postdiscount) !== undefined
                                ? (finalSubtotal.toLocaleString("vi-VN"))
                                : "N/A"}
                        </div>
                    </div>
                ) : null}

                <div className="row summary-item mb-3">
                    <div className="col-6">{t("Tax")} (10%)</div>
                    <div className="col-6 text-end">
                        {(props?.taxAmount) !== null
                            ? (props?.taxAmount).toLocaleString("vi-VN")
                            : "N/A"}
                    </div>
                </div>

                {/* Tổng thanh toán */}
                <div className="row summary-item mb-3">
                    <div className="col-6">
                        <h4 style={{ fontSize: "17px" }}>{t("Total Amount")}</h4>
                    </div>
                    <div className="col-6 text-end">
                        {(props?.paymentAmount) !== null
                            ? (props?.paymentAmount).toLocaleString("vi-VN")
                            : "N/A"}
                    </div>
                </div>
                <h5 style={{ color: "green", backgroundColor: "#d4edda", fontSize: "14px", fontWeight: "bold", textAlign: "center" }} className="success-message">
                    {discountSuccess}
                </h5>
                <h5 style={{ color: "red", backgroundColor: "#f8d7da", fontSize: "14px", fontWeight: "bold", textAlign: "center" }} className="error-message">{checkeror}</h5>
            </div>

            {/* Nút thanh toán */}
            <div className="checkout-button-container mt-4 text-center">
                {/* <PayPalScriptProvider
                    options={{
                        "client-id": "ASMqZ4b9b8uMhsKouyqaEAkZ8s3EyKWk7XzFN_pe5VV-7i0YB7fpkjAbglNiUHTd_YFBKAb7t1oQj5Oq", // Thay bằng Client ID thật của bạn
                    }}
                >
                    <PayPalButtons
                        createOrder={(data, actions) => {
                            const currentUsdPrice = (price / 23000).toFixed(2);
                            if (!currentUsdPrice || currentUsdPrice <= 0) {
                                alert("Giá trị thanh toán không hợp lệ. Vui lòng kiểm tra lại.");
                                return;
                            }

                            return actions.order.create({
                                purchase_units: [
                                    {
                                        amount: {
                                            value: currentUsdPrice,
                                        },
                                    },
                                ],
                            });
                        }}
                        onApprove={(data, actions) => {
                            return actions.order.capture().then((details) => {
                                alert("Thanh toán thành công!");
                                // console.log("Transaction Details:", details);

                            });
                        }}
                        onCancel={() => {
                            alert("Bạn đã hủy giao dịch. Vui lòng thử lại nếu cần.");
                            // console.log("Giao dịch bị hủy bởi người dùng.");

                        }}
                        onError={(err) => {
                            console.error("Lỗi thanh toán:", err);
                            alert("Đã xảy ra lỗi khi thanh toán.");
                        }}
                    />
                </PayPalScriptProvider> */}
                <div className="promo-code-container mb-3 d-flex align-items-center">
                    <input
                        type="text"
                        className="form-control me-2"
                        placeholder="Mã khuyến mãi"
                        value={promoCode}

                        onChange={(e) => setPromoCode(e.target.value)}
                        style={{
                            borderRadius: "20px",
                            padding: "10px",
                            fontSize: "14px",
                        }}
                    />
                    <button
                        className=""
                        // onClick={() => console.log("Mã khuyến mãi:", promoCode)} 
                        onClick={handleDiscount}
                        style={{
                            border: "1px solid white",
                            borderRadius: "50px",
                            fontWeight: "bold",
                            width: "50%",
                            background: "rgb(0, 105, 255)",
                            padding: "4px",
                            color: "#fff"
                        }}
                    >
                        {t("Apply")}
                    </button>
                </div>

                <button
                    className="checkout-button"
                    onClick={handleCreateInvoice}
                    style={{
                        width: "100%",
                        fontFamily: "Arial, sans-serif",
                        fontSize: "16px",
                        fontWeight: "bold"
                    }}
                >
                    {t("Make a Payment")}
                </button>

            </div>
        </div>
    );
}

export default Invoice;
